import React from 'react';
import './clases.css'
import { Fade } from "react-awesome-reveal";


function Clases() {
    return (
    <section className="clasescontainer" id="clasescontainer">
        <div className="clasestexto">
            <Fade bottom delay={100} duration={1000}  fraction={0.2}><h2>CLASES</h2></Fade>
            <Fade bottom delay={100} duration={1000}  fraction={0.3}>
                <p>Amy has been teaching for over fifteen years in various settings, including many years in the Programa
Nacional de Orquestas y Coros Infantiles y Juveniles para el Bicentenario of the Ministry of Education
of Argentina. She worked as a violin teacher and educator trainer, with a
special focus on group work.Her teaching experience spans a wide range of audiences, from children
to adults.</p>
                <p>In her classes, she covers both the specific technique of the instrument and general musical
elements, such as improvisation and composition.</p>
                        
            </Fade>
        </div>
        <div className="clasesspotify">
            <Fade>
                <iframe className='stliframe' src="https://open.spotify.com/embed/artist/3AGGyNDwL2K76SPArpC4QN?utm_source=generator&theme=0" title="Spotify media player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" loading="lazy"></iframe>
            </Fade>
        </div>
    </section>
)
}

export default Clases